import { render } from "./UiSidebar.vue?vue&type=template&id=0216df86"
import script from "./UiSidebar.vue?vue&type=script&lang=js"
export * from "./UiSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__